
import { Component, OnInit, Inject, Optional, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LanguageService } from '../../shared/services/language.service';
import { ProjectTypesService } from '../../shared/services/project-types.service';
import {
  MAT_TOOLTIP_DEFAULT_OPTIONS,
  MatTooltipDefaultOptions,
  MatTooltipModule,
} from '@angular/material/tooltip';
import { InfoBarWithStatusService } from '../../shared/services/info-bar-with-status.service';
import { Permission } from '../../shared/security/permission';

export const myCustomTooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 500,
  hideDelay: 500,
  touchendHideDelay: 500,
};

@Component({
  standalone: false,
  selector: 'app-sub-tasks-dialog',
  templateUrl: './sub-tasks-dialog.component.html',
  styleUrls: ['./sub-tasks-dialog.component.css'],
  providers: [{ provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: myCustomTooltipDefaults }],
})
export class SubTasksDialogComponent implements OnInit {

  Permission = Permission
  variables: any;

  //Temporary static items.
  items: any;

  local_data: any; //local data is the data that has been passed from the parent to this dialog and will be passed back to the parent.

  invalidInputSubTask: boolean = false;
  errorMessageSubTask: string = '';

  isAction: boolean = false;
  isUsers: boolean = false;
  isSubTask: boolean = false;
  isProjectType: boolean = false;
  isConfigurationType: boolean = false;
  isMacroActivities: boolean = false;
  isMacroActivitiesType: boolean = false;
  showMacro: boolean = false;
  filteredMacro: any[] = [];

  formGroup1: any;

  effort = '';

  otherType = false; //Flag to check if the user will add a custom input or use a predefined type.
  otherTypeMacro = false;

  riskInputEffort: any;

  isActionType: boolean = false;
  isEdit = false;

  listInDB: any;

  constructor(private projectTypesService: ProjectTypesService,
    public dialogRef: MatDialogRef<SubTasksDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _formBuilder: FormBuilder,
    private infoBar: InfoBarWithStatusService,
    private languageService: LanguageService
  ) {
    this.local_data = { ...data };
    this.items = [
      { name: this.variables?.implementation },
      { name: 'Review' },
      { name: this.variables?.other }
    ];
  }

  ngOnInit(): void {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;

      this.items = [
        { name: this.variables?.implementation },
        { name: 'Review' },
        { name: this.variables?.other }
      ];

      this.effort = this.variables?.hours;
    });

    this.isEdit = this.local_data.isEdit

    if (this.isEdit) {
      this.formGroup1 = this._formBuilder.group({
        firstCtrlUser: [this.local_data.item.name, Validators.required],
      });
    }
    else {
      this.formGroup1 = this._formBuilder.group({
        firstCtrlUser: ['', Validators.required],
      });
    }

    if (this.local_data.effort) this.effort = this.local_data.effort;
    this.listInDB = this.local_data.listInDB;
  }


  validateUniqueName() {
    const nameToValidate = this.formGroup1.get('firstCtrlUser')?.value?.trim()

    const exists = this.listInDB.some((item: any) => item.name === nameToValidate);

    if (exists) {
      return false
    } else {
      return true
    }
  }


  cleanErrors() {
    this.invalidInputSubTask = false;
    this.errorMessageSubTask = '';
  }


  doAction() {
    const formGroup = this.formGroup1.value;
    let valid = true;
    this.cleanErrors()
    /*
      Check if all the inputs have been filled.
    */

    if ((formGroup.firstCtrlUser.length <= 0 || !formGroup.firstCtrlUser)) {
      this.invalidInputSubTask = true;
      this.errorMessageSubTask = this.variables.mandatorySubTask;
      valid = false;
    }

    if (!this.validateUniqueName()) {
      this.invalidInputSubTask = true;
      if (!this.isEdit) {
        this.errorMessageSubTask = this.variables.snackBarErrorAddAction;
      }
      else {
        this.errorMessageSubTask = this.variables.snackBarErrorEditAction;
      }
      valid = false;
    }

    //Pass data
    if (valid) {
      this.local_data.subTaskName = formGroup.firstCtrlUser;
      this.dialogRef.close({ data: this.local_data })
    } else {
      this.infoBar.showSnackbar(this.variables.errorInForm, ['error-snackbar'], 2000);

    };


  }
}
